import {
  DEFAULT_MAX_CHAR_LENGTH,
  DEFAULT_REDACTION_POLICY,
  DEFAULT_WRITE_POLICY,
} from 'dashboard/apps/InquiryTemplateEditor/FieldPanel/shared';
import { Identifier } from 'dashboard/models/identifier';
import { FIELD_SCHEMA_TYPE_DISPLAY, FieldSchema, FieldSchemaType } from 'lib/fields';

export type FormValueArrayPath =
  | 'fieldSchemas'
  | `fieldSchemas.${number}.config.item-schemas`
  | `fieldSchemas.${number}.config.item-schema.config.item-schemas`;

export const DEFAULT_FIELD_SCHEMA: FieldSchema = {
  type: FieldSchemaType.String,
  label: '',
  key: '',
  'default-value': null,
  config: {
    'redaction-policy': DEFAULT_REDACTION_POLICY,
    'write-policy': DEFAULT_WRITE_POLICY,
    'max-char-length': DEFAULT_MAX_CHAR_LENGTH,
  },
};

export const DEFAULT_ARRAY_ITEM_SCHEMA: FieldSchema = {
  type: FieldSchemaType.String,
  label: '',
  key: 'array_item',
  'default-value': null,
  config: {
    'redaction-policy': DEFAULT_REDACTION_POLICY,
    'write-policy': DEFAULT_WRITE_POLICY,
    'max-char-length': DEFAULT_MAX_CHAR_LENGTH,
  },
};

export type FocusReason = 'add' | 'edit' | 'move';

export enum RelationSchemaType {
  RelationSchema = 'relation-schema',
}

export type FieldSchemaEditorSupportedTypes = FieldSchema | FieldSchemaRelationSchema;

// useFieldArray from react-hook-form returns an array of objects with an id field
// we also need indexes at the top level because we need useFieldArray to know what index to use
// even if Fuse filters down the results
export type EditorableSchemaWithId = EditorableSchema & { id: string } & { index?: number };

export type EditorableSchema = FieldSchemaEditorSupportedTypes & {
  // augment with identifier configuration
  identifier?: Identifier;
  persisted?: boolean;
};

export const FIELD_SCHEMA_EDITOR_SUPPORTED_FIELD_TYPE_OPTIONS_DISPLAY = {
  ...FIELD_SCHEMA_TYPE_DISPLAY,
  [RelationSchemaType.RelationSchema]: 'Relation',
};
export interface FieldSchemaRelationSchema {
  type: RelationSchemaType.RelationSchema;
  config: any;
  token: string;
  key: string;
  label: string;
  cardinality: 'one' | 'many';
  'inverse-key'?: string;
  'inverse-label'?: string;
  'inverse-cardinality'?: 'one' | 'many';
}
